import axios from 'axios';

export const policy = {
    state: {
        policy: [],
        policybyid: []

    },
    mutations: {
        policy(state, data){
            state.policy = data.subscriptions
            },
        policybyid(state, data){
            state.policybyid = data.subscription

            },
            
    },
    actions: {
        getPolicies: ({commit})=>{
            return new Promise((resolve, reject)=>{
              axios.get("/subscriptions")
              .then(({status, data})=>{
                if(status === 200){
                  resolve(data);
                  commit("policy", data)
                }
              })
              .catch((error)=>{
                reject(error);
              });
            })
          },
        // get policy by filters
        PolicyFilters: ({commit}, payload)=>{
          return new Promise((resolve, reject)=>{
            axios.get(`/subscriptions?isActive=${payload.isActive}`)
            .then(({status, data})=>{
              if(status === 200){
                resolve(data);
                commit("policy", data)
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
        },

        // get expired polices
        PolicyExpiredFilters: ({commit}, payload)=>{
          return new Promise((resolve, reject)=>{
            axios.get(`/subscriptions?isExpired=${payload.isExpired}`)
            .then(({status, data})=>{
              if(status === 200){
                resolve(data);
                commit("policy", data)
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
        },
          
        //   already in use at community module
          PolicyById: ({commit},payload)=>{
            return new Promise((resolve, reject)=>{
                axios.get("/subscriptions/"+payload)
                .then(({status, data})=>{
                  if(status === 200){
                    resolve(data)
                    commit('policybyid', data)
                  }
                })
                .catch((error)=>{
                  reject(error);
                })
              }); 
          }

    }

}
